import {
  CUSTOMER_STORIES_HOME,
  PRODUCT_TOUR_PAGE,
  RESOURCES_HOME,
} from '@/constants/routes';
import gtm from '@/lib/gtm';
import Link from 'next/link';
import React from 'react';

interface ConfirmationProps {
  userFirstName: string;
  onClose?: () => void;
  meetingOffered: boolean;
}

const Confirmation: React.FC<ConfirmationProps> = ({ userFirstName, onClose, meetingOffered = false }) => {
  const heading = `Thank you, ${userFirstName ?? 'friend'}!`;
  const subheading = meetingOffered ? "We look forward to meeting with you." : "Here's what you can expect next.";

  return (
    <>
      <h3 className='text-h4 font-600 mt-2'>{heading}</h3>
      <p className='text-caption2 font-500 mt-1'>{subheading}</p>
      {meetingOffered ? (
        <h4 className='text-p2 mt-3 mb-[4px] font-600'>In the meantime, there are a few ways to explore Front on your own.</h4>
      ) : (
        <>
          <h4 className='text-p2 mt-3 mb-[4px] font-600'>We’ll be in touch</h4>

          <p>
            A product expert will call or email you soon to set up a time to chat. We’ll ask about your workflows
            to prepare a personalized demo that fits your team’s unique needs.
          </p>

          <p className='mt-2'>In the meantime, there are a few ways to explore Front on your own.</p>
        </>
      )
      }

      <ul className='mt-3'>
        <li className='mb-1'>

          <Link
            href={PRODUCT_TOUR_PAGE}
            className='text-caption1 font-500 border-solid border-b-2 border-b-black'
            onClick={() => {
              onClose?.();
              gtm.track('click', {
                element_type: 'link',
                element_label: 'Explore our product tour',
                location: `Form Success - Demo Modal`,
              });
            }}
          >
            Explore our product tour &rarr;
          </Link>

        </li>

        <li className='mb-1'>

          <Link
            href={RESOURCES_HOME}
            className='text-caption1 font-500 border-solid border-b-2 border-b-black'
            onClick={() => {
              onClose?.();
              gtm.track('click', {
                element_type: 'link',
                element_label: 'Check out our resource hub',
                location: `Form Success - Demo Modal`,
              });
            }}
          >
            Check out our resource hub &rarr;
          </Link>

        </li>

        <li className='mb-1'>

          <Link
            href={CUSTOMER_STORIES_HOME}
            className='text-caption1 font-500 border-solid border-b-2 border-b-black'
            onClick={() => {
              onClose?.();
              gtm.track('click', {
                element_type: 'link',
                element_label: 'Meet our customers',
                location: `Form Success - Demo Modal`,
              });
            }}
          >
            Meet our customers &rarr;
          </Link>

        </li>
      </ul>
    </ >
  );
};

export default Confirmation;
